import React, { useEffect, useState } from 'react';

import DoorDashFavorite from '@/components/views/Admin/components/FileImageComponent/DoorDashFavorite';

interface SvgBgPrimaryProps {
  svgURL: string;
  height: number;
  width: number;
  colorClass?: string; // Nueva prop para el color personalizado
}

const SvgBgPrimary: React.FC<SvgBgPrimaryProps> = ({
  svgURL,
  height,
  width,
  colorClass = 'text-primary',
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [svgContent, setSvgContent] = useState<string | null>(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (svgURL && !svgURL.includes('null')) {
      fetch(svgURL)
        .then((response) => {
          // Verificar si la respuesta es exitosa
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((svg) => {
          // Verificar si el contenido es realmente un SVG
          if (svg.includes('<svg') || svg.trim().startsWith('<svg')) {
            setSvgContent(svg);
            setHasError(false);
          } else {
            // Si no es un SVG válido, marcar como error
            console.error('Invalid SVG content received');
            setSvgContent(null);
            setHasError(true);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching SVG:', err);
          setIsLoading(false);
          setSvgContent(null);
          setHasError(true);
        });
    } else {
      setIsLoading(false);
      setHasError(true);
    }
  }, [svgURL]);

  return (
    <>
      {isLoading ? (
        <DoorDashFavorite />
      ) : hasError || !svgContent ? (
        // Mostrar un ícono de fallback en lugar de solo un fondo
        <div
          className="flex items-center justify-center rounded-lg"
          style={{ width: width, height: height }}
        >
          <svg
            className="text-primary"
            width={width * 0.6}
            height={height * 0.6}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      ) : (
        <div
          className="relative overflow-hidden"
          style={{ width: width, height: height, position: 'relative' }}
        >
          <div
            className={`fill-current ${colorClass} [&>svg>g]:${colorClass} [&>svg]:size-full [&_*]:!fill-current`}
            style={{ width: width, height: height }}
            dangerouslySetInnerHTML={{
              __html: svgContent?.replace(/fill="[^"]*"/g, `fill="currentColor"`) ?? '',
            }}
          />
        </div>
      )}
    </>
  );
};

export default SvgBgPrimary;
